/*
* <license header>
*/

import React, { useState } from 'react'
import { Button, Flex, Heading, TextField, View } from '@adobe/react-spectrum'
import { PageHeaderBanner } from './shared/PageHeaderBanner'
import { AppAssistant } from './shared/AppAssistant'

const PARAM_FIELDS = [
  { label: 'App name', key: 'appName', placeholder: 'e.g. My Awesome App' },
  { label: 'Adobe I/O Project name', key: 'adobeIoProjectName', placeholder: 'e.g. AppBuilder Factory' },
  { label: 'Repository', key: 'repository', placeholder: 'e.g. owner/repo-name' },
  { label: 'Application type', key: 'applicationType', placeholder: 'e.g. Unified Shell Application' },
  { label: 'URL', key: 'url', placeholder: 'e.g. https://27200-appbuilderfactory-stage.adobeio-static.net' }
]

export const Wizard = () => {
  const [params, setParams] = useState({
    appName: '',
    adobeIoProjectName: '',
    repository: '',
    applicationType: '',
    url: ''
  })

  const handleParamChange = (key, value) => {
    setParams((prev) => ({ ...prev, [key]: value }))
  }

  return (
  <View width="100%" padding="size-400" UNSAFE_style={{ paddingBottom: '2.5rem' }}>
    <PageHeaderBanner
      title="AppBuilder Factory"
      subtitle="Wizard"
    />

    <View
      UNSAFE_style={{
        border: '1px solid var(--card-border)',
        borderRadius: '8px',
        padding: '1.25rem',
        backgroundColor: 'var(--white)'
      }}
      marginBottom="size-300"
    >
      <Heading level={2} UNSAFE_style={{ margin: 0, marginBottom: '0.75rem', fontSize: '1.125rem' }}>
        Parameters
      </Heading>
      <View UNSAFE_style={{ overflow: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.875rem' }}>
          <tbody>
            {PARAM_FIELDS.map(({ label, key, placeholder }) => (
              <tr key={key}>
                <td style={{ padding: '0.5rem 1rem 0.5rem 0', fontWeight: 600, color: 'var(--gray-900)', verticalAlign: 'top', width: '180px' }}>
                  {label}
                </td>
                <td style={{ padding: '0.5rem 0', color: 'var(--gray-700)' }}>
                  <TextField
                    aria-label={label}
                    value={params[key]}
                    onChange={(value) => handleParamChange(key, value)}
                    placeholder={placeholder}
                    width="100%"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </View>
    </View>

    <View
      UNSAFE_style={{
        border: '1px solid var(--card-border)',
        borderRadius: '8px',
        padding: '1.25rem',
        backgroundColor: 'var(--white)'
      }}
      marginBottom="size-300"
    >
      <Heading level={2} UNSAFE_style={{ margin: 0, marginBottom: '0.75rem', fontSize: '1.125rem' }}>
        App Actions
      </Heading>
      <Flex gap="size-100" wrap>
        <Button variant="accent" onPress={() => console.log('Create')} marginEnd="size-200">
          Create
        </Button>
        <Button variant="secondary" onPress={() => console.log('Save Draft')} marginEnd="size-200">
          Save Draft
        </Button>
        <Button variant="primary" onPress={() => console.log('Seed')} marginEnd="size-200">
          Seed
        </Button>
      </Flex>
    </View>

    <AppAssistant />
  </View>
  )
}
